import React from "react";
import { CHART_COLORS } from "@/features/investors/components/charts/palette";

export type HeatmapCell = {
    value: number | null;
    isFuture: boolean;
};

export type HeatmapRow = {
    label: string;
    sub: string;
    cells: HeatmapCell[];
};

type Props = {
    rows: HeatmapRow[];
    columns: string[];
    baseColor?: string;
};

const alphaHex = (value: number): string =>
    Math.round((0.12 + (value / 100) * 0.88) * 255)
        .toString(16)
        .padStart(2, "0");

export const Heatmap: React.FC<Props> = ({ rows, columns, baseColor = CHART_COLORS.blue }) => (
    <table className="heatmap">
        <thead>
            <tr>
                <th className="hm-corner">Cohort</th>
                {columns.map((column) => (
                    <th key={column}>{column}</th>
                ))}
            </tr>
        </thead>
        <tbody>
            {rows.map((row) => (
                <tr key={row.label}>
                    <td className="hm-row-lab">
                        <b>{row.label}</b>
                        <span>{row.sub}</span>
                    </td>
                    {row.cells.map((cell, index) => {
                        if (cell.isFuture || cell.value === null) {
                            return <td key={columns[index]} className="hm-cell hm-future" />;
                        }
                        const rounded = Math.round(cell.value);
                        return (
                            <td
                                key={columns[index]}
                                className="hm-cell"
                                style={{
                                    background: `${baseColor}${alphaHex(rounded)}`,
                                    color: rounded > 55 ? "#06121A" : "#CBD5E1",
                                }}
                                data-tip={`${rounded}% retained`}
                            >
                                {rounded}%
                            </td>
                        );
                    })}
                </tr>
            ))}
        </tbody>
    </table>
);
